module.exports = __webpack_public_path__ + "resources/checkmark-filled-73f2a848d88d105459267e9f5510408d.svg";